var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000183935388538406180970000008276681591026244009_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.4,246.6c33.9,0,63.2-12.2,87.2-36.1c24-24,36.1-53.3,36.1-87.2s-12.2-63.2-36.1-87.2 c-24-24-53.3-36.1-87.2-36.1s-63.2,12.2-87.2,36.1S129,89.4,129,123.3s12.2,63.2,36.1,87.2C189.1,234.5,218.5,246.6,252.4,246.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 252.6,
    cy: 355.5,
    r: 12.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.1,393.7c-0.7-10-2.1-20.9-4.1-32.4c-2.1-11.6-4.8-22.5-8-32.5c-3.3-10.3-7.8-20.6-13.4-30.3 c-5.8-10.2-12.6-19-20.2-26.3c-8-7.6-17.7-13.7-29-18.2c-11.2-4.4-23.7-6.7-37-6.7c-5.2,0-10.3,2.1-20,8.5 c-6,3.9-13,8.4-20.9,13.5c-6.7,4.3-15.8,8.3-27,11.9c-10.9,3.5-22.1,5.3-33,5.3c-10.9,0-22.1-1.8-33-5.3 c-11.2-3.6-20.3-7.6-27-11.9c-7.8-5-14.8-9.5-20.9-13.5c-9.8-6.4-14.8-8.5-20-8.5c-13.3,0-25.8,2.3-37,6.7 c-11.3,4.5-21,10.6-29,18.2c-7.6,7.3-14.4,16.1-20.2,26.3c-5.6,9.8-10.1,20-13.4,30.3c-3.2,10-5.9,20.9-8,32.5 c-2.1,11.5-3.5,22.4-4.1,32.4c-0.7,9.8-1,20-1,30.2c0,26.7,8.5,48.4,25.2,64.3C83.8,504,105.7,512,132.3,512h246.5 c26.6,0,48.5-8,65.1-23.7c16.8-15.9,25.3-37.6,25.3-64.3C469.2,413.6,468.8,403.5,468.1,393.7z M252.6,477.2 c-43.6,0-79.1-35.5-79.1-79.1c0-43.6,35.5-79.1,79.1-79.1c43.6,0,79.1,35.5,79.1,79.1C331.7,441.7,296.2,477.2,252.6,477.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.6,385.9c-6.8,0-12.2,5.5-12.2,12.2v42.6c0,6.7,5.5,12.2,12.2,12.2c6.8,0,12.2-5.5,12.2-12.2v-42.6 C264.8,391.4,259.3,385.9,252.6,385.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfo);
export default __webpack_public_path__ + "static/media/personal_info.0275ab1881ffc62c6db814ab33db2f67.svg";
export { ForwardRef as ReactComponent };